import {Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {Login} from './components/Login'
import {VerifyEmail} from './components/VerifyEmail'
import {ClientPortalUserRegistration} from './components/ClientPortalUserRegistration'
import {ClientPortalLogin} from './components/ClientPortalLogin'
import {AuthLayout} from './AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      {/* Rotas do portal do cliente devem vir PRIMEIRO para serem capturadas antes das outras */}
      <Route path='area-do-cliente/cadastro' element={<ClientPortalUserRegistration />} />
      <Route path='area-do-cliente/login' element={<ClientPortalLogin />} />
      {/* Rotas do sistema principal */}
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ResetPassword />} />
      <Route path='verify-email' element={<VerifyEmail />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
